import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Profile from "./Profile";

// Import Modal
import Modal from "react-bootstrap/Modal";

//Import Moment JS
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

//Import Accordion
import Accordion from "react-bootstrap/Accordion";

//Import service
// import academyService from "../../services/academy.service";
import farmermasterService from "services/farmermaster.service";
import farmerService from "../../services/farmer.service";
import UserService from "../../services/user.service";

//Import CSS
import "./Modaladddetail.css";

function ModalEditDetail(props) {
  const [assoc, setAssoc] = useState([]);
  const [factory, setFactory] = useState([]);
  const [farmer, setFarmer] = useState({});
  const [assocselected, setAssocSelected] = useState({
    association_id: "1",
    association_name_th: "ไม่ระบุสถาบัน",
  });
  const [academylist, setAcademylist] = useState([]);
  const [directsent, setDirectsent] = useState([]);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({ deed_owner: "ตนเอง" });
  const [undersent, setUndersent] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [refreshImg, setRefreshImg] = useState(true);
  const [plant, setPlant] = useState([]);
  const [approveStatus, setApproveStatus] = useState("ฉบับร่าง");

  const afterSaveFarmer = (item) => {
    setRefreshImg(false);
    setFarmer({
      id_card: item.farmer_idcard,
      pre_name: item.farmer_nametitle,
      first_name: item.farmer_name,
      last_name: item.farmer_lastname,
      prov_namt: item.masterLocation.provinceDesc,
      amp_namt: item.masterLocation.districtDesc,
      tam_namt: item.masterLocation.subdistrictDesc,
      sex: item.farmer_gender,
      tel: item.farmer_phone,
      address: item.farmer_address,
      birth_date: item.farmer_birthday,
      farmer_image: item.farmer_image,
      farmer_id: item.farmer_id,
      cwt: item.masterLocation.provinceCode,
      region: item.region_id,
    });
    setRefreshImg(true);
  };

  const renderTooltip = (props) => (
    <Tooltip {...props}>คลิ๊ก เปิด-ปิด แก้ไขข้อมูล</Tooltip>
  );

  const checkID = (id) => {
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  };

  const getAssocMember = (master_id) => {
    farmermasterService.getMasterAssocMember(master_id).then((response) => {
      if (response.data.success) {
        setAssoc(response.data.data);
      }
    });
  };

  const getDirectSent = (master_id) => {
    farmermasterService.getMasterDirect(master_id).then((response) => {
      if (response.data.success) {
        setDirectsent(response.data.data);
      }
    });
  };

  const getMasterDeed = (master_id) => {
    farmermasterService.getMasterDeed(master_id).then((response) => {
      if (response.data.success) {
        setPlant(response.data.data);
      }
    });
  };

  const getUnderSent = (master_id) => {
    farmermasterService.getMasterUnder(master_id).then((response) => {
      if (response.data.success) {
        setUndersent(response.data.data);
      }
    });
  };

  const handleRemoveItemUnder = (id) => {
    setUndersent(undersent.filter((item) => item.under_idcard !== id));
  };
  const findUnderErrors = () => {
    const { under_idcard, under_fullname, under_sent } = form;
    const newErrors = {};

    if (!under_idcard || under_idcard === "") {
      newErrors.under_idcard = "กรุณากรอกเลขบัตรประชาชน";
    } else {
      if (!checkID(under_idcard))
        newErrors.under_idcard = "เลขบัตรประชาชนไม่ถูกต้อง";
    }

    if (!under_fullname || under_fullname === "")
      newErrors.under_fullname = "กรุณากรอกชื่อ-สกุล";

    if (!under_sent || under_sent === "")
      newErrors.under_sent = "กรุณากรอกจำนวนอ้อย";

    return newErrors;
  };

  const handleAddUnder = (e) => {
    e.preventDefault();
    const newErrors = findUnderErrors();
    if (
      newErrors.under_idcard ||
      newErrors.under_fullname ||
      newErrors.under_sent
    ) {
      setErrors(newErrors);
    } else {
      const underfilter = undersent.filter(
        (item) => item.under_idcard != form.under_idcard
      );
      setUndersent([
        ...underfilter,
        {
          under_idcard: form.under_idcard,
          under_fullname: form.under_fullname,
          under_sent: form.under_sent,
        },
      ]);
      setForm({
        ...form,
        under_idcard: "",
        under_fullname: "",
        under_sent: "",
      });
    }
  };

  const handleRemoveItemDirect = (id) => {
    setDirectsent(directsent.filter((item) => item.factory_id !== id));
  };
  const handleAddDirect = (e) => {
    e.preventDefault();
    const newErrors = findDirectErrors();
    if (newErrors.direct_sent || newErrors.factory) {
      setErrors(newErrors);
    } else {
      const directfilter = directsent.filter(
        (item) => item.factory_id != form.factory.factory_id
      );
      setDirectsent([
        ...directfilter,
        {
          factory_id: form.factory.factory_id,
          factory_name: form.factory.factory_name,
          direct_sent: form.direct_sent,
        },
      ]);
      setForm({
        ...form,
        factory: {
          factory_id: "",
          factory_name: "",
        },
        direct_sent: "",
      });
    }
  };
  const setField = (field, value) => {
    if (field.name == "factory") {
      let index = field.selectedIndex;
      let label = field[index].text;
      setForm({
        ...form,
        [field.name]: { factory_id: value, factory_name: label },
      });
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
    }
    setErrors({
      ...errors,
      [field.name]: null,
    });
    if (field.name === "under_idcard") {
      if (checkID(value)) {
        farmerService.getFarmerById(value).then((res) => {
          if (res.data.success) {
            const fullname =
              res.data.farmer.pre_name +
              " " +
              res.data.farmer.first_name +
              " " +
              res.data.farmer.last_name;
            setForm((a) => ({ ...a, ["under_fullname"]: fullname }));
          }
        });
      }
    }
  };

  const findDirectErrors = () => {
    const { factory, direct_sent } = form;
    const newErrors = {};

    // start date errors
    if (!factory || factory.factory_id == "")
      newErrors.factory = "กรุณากรอกโรงงาน";

    if (!direct_sent || direct_sent === "")
      newErrors.direct_sent = "กรุณากรอกโรงงาน";

    return newErrors;
  };

  const handleClose = () => {
    props.hidden(false);
    setErrors({});
    setToggle(true);
  };
  const getFactory = () => {
    UserService.getFactorylist()
      .then((response) => {
        setFactory(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getFactory: ", error);
      });
  };
  const getAcademy = () => {
    UserService.getAcademylist()
      .then((response) => {
        setAcademylist(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getAcademy: ", error);
      });
  };
  // const getMember = (farmer_idcard) => {
  //   academyService.getAcademyByPersonId(farmer_idcard).then((response) => {
  //     if (response.data.success) {
  //       console.log(response.data.data);
  //       setAssoc(response.data.data);
  //     }
  //   });
  // };
  const getFarmer = (farmer_idcard) => {
    farmerService.getFarmerById(farmer_idcard).then((response) => {
      setFarmer(response.data.farmer);
    });
  };
  useEffect(() => {
    getFactory();
    getAcademy();
  }, []);

  useEffect(() => {
    if (Object.keys(props.master_select).length != 0) {
      getAssocMember(props.master_select.masterid);
      getFarmer(props.master_select.masteridcard);
      getDirectSent(props.master_select.masterid);
      getUnderSent(props.master_select.masterid);
      getMasterDeed(props.master_select.masterid);
      setApproveStatus(props.master_select.approve_status);
    }
  }, [props.master_select.masterid]);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.afterSubmit({
      farmer_idcard: props.master_select.masteridcard,
      farmer_id: farmer.farmer_id,
      farmer_prename: farmer.pre_name,
      farmer_firstname: farmer.first_name,
      farmer_lastname: farmer.last_name,
      farmer_gender: farmer.sex,
      farmer_birthday: farmer.birth_date,
      farmer_tel: farmer.tel,
      farmer_address: farmer.address,
      tam_namt: farmer.tam_namt,
      amp_namt: farmer.amp_namt,
      prov_namt: farmer.prov_namt,
      assoc: assoc,
      directsent: directsent,
      undersent: undersent,
      plant: plant,
      approve_status: approveStatus,
    });
  };

  const setAssocSelect = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    let value = e.target.value;
    setAssocSelected({
      association_id: value,
      association_name_th: label,
    });
  };

  const findDeedErrors = () => {
    const { deed_type, deed_owner, deed_rai } = form;
    const newErrors = {};

    if (!deed_type || deed_type == "")
      newErrors.deed_type = "กรุณาเลือกการเช่า";
    if (!deed_rai || deed_rai == 0) newErrors.deed_rai = "กรุณากรอกจำนวนไร่";
    if (!deed_owner || deed_owner == "") newErrors.deed_owner = "กรุณาเลือก";
    return newErrors;
  };
  const handleRemoveItemPlant = (key) => {
    setPlant(plant.filter((item, index) => index !== key));
  };
  const handleAddPlant = (e) => {
    e.preventDefault();
    const newErrors = findDeedErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setPlant([
        ...plant,
        {
          deed_type: form.deed_type,
          deed_owner: form.deed_owner ? form.deed_owner : "-",
          deed_rai: form.deed_rai ? form.deed_rai : 0,
        },
      ]);
      setForm({
        ...form,
        deed_type: "",
        deed_owner: "ตนเอง",
        deed_rai: "",
      });
    }
  };
  const setDeed = (field, value) => {
    setForm({
      ...form,
      [field.name]: value,
    });
    setErrors({
      ...errors,
      [field.name]: null,
    });
  };
  const clickAddAssoc = (e) => {
    e.preventDefault();
    if (assocselected.association_id !== "1") {
      setAssoc([
        ...assoc.filter(
          (a) =>
            a.association_id != assocselected.association_id &&
            a.association_id != 1
        ),
        assocselected,
      ]);
    } else {
      setAssoc([assocselected]);
    }
    setAssocSelected({
      association_id: "1",
      association_name_th: "ไม่ระบุสถาบัน",
    });
  };

  const handleRemoveItem = (id) => {
    setAssoc(assoc.filter((item) => item.association_id !== id));
  };

  // const Item = ({ item, onRemove }) => (
  //   <li key={item.association_id}>
  //   {item.association_name_th}
  //   <button onClick={onRemove(item.association_id)}>
  //     <i className="bi bi-x"></i>
  //   </button>
  // </li>
  // );

  // const List = ({ list, onRemove }) => (
  //   <ul>
  //     {list.map((item) => (
  //       <Item key={item.association_id} item={item} onRemove={onRemove} />
  //     ))}
  //   </ul>
  // );

  return (
    <>
      <Modal size="xl" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขข้อมูลการจดทะเบียน หน.กลุ่ม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0" alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>ข้อมูลพื้นฐาน</Accordion.Header>
              <Accordion.Body>
                <Profile
                  hidden={toggle}
                  farmer_idcard={props.master_select.masteridcard}
                  aftersubmit={afterSaveFarmer}
                  toggle={() => setToggle((a) => !a)}
                />
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <i
                    className="bi bi-pencil"
                    onClick={() => setToggle((a) => !a)}
                  ></i>
                </OverlayTrigger>
                <br />
                <div className="container farmer-profile">
                  <div className="farmer-profile-img">
                    <img
                      src={
                        refreshImg
                          ? process.env.REACT_APP_API +
                            "/images/farmer/" +
                            farmer.farmer_image +
                            "?" +
                            new Date().getTime()
                          : ""
                      }
                      alt="dummy"
                      width="150"
                      height="150"
                    />
                  </div>
                  <br />
                  <span>ชื่อ - นามสกุล : </span>{" "}
                  {farmer.pre_name +
                    " " +
                    farmer.first_name +
                    " " +
                    farmer.last_name}
                  <br />
                  <span>ที่อยู่ : </span>{" "}
                  {farmer.address +
                    " แขวง/ตำบล " +
                    farmer.tam_namt +
                    " เขต/อำเภอ " +
                    farmer.amp_namt +
                    " จังหวัด " +
                    farmer.prov_namt}
                  <br />
                  <span>เพศ : </span>
                  {farmer.sex}
                  <br />
                  <span>วันเกิด : </span>
                  {moment(farmer.birth_date)
                    .add(543, "year")
                    .locale("th")
                    .format("ll")}
                  <br />
                  <span>เบอร์โทร : </span>
                  {farmer.tel}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>ข้อมูลการเป็นสมาชิกสถาบัน</Accordion.Header>
              <Accordion.Body>
                <Form>
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Select
                          name="acdemy"
                          value={assocselected.association_id}
                          onChange={setAssocSelect}
                          // isInvalid={!!errors.academy}
                        >
                          {academylist.map((o) => (
                            <option key={o.academyId} value={o.academyId}>
                              {o.academyName}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <button
                          className="btn btn-primary btn-add-detail"
                          onClick={clickAddAssoc}
                        >
                          เพิ่ม
                        </button>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                {assoc.map((item) => {
                  return (
                    <>
                      <p
                        name={item.association_id}
                        onClick={() => handleRemoveItem(item.association_id)}
                      >
                        {item.association_name_th}
                        <i
                          className="bi bi-x cademy-ui"
                          style={{ color: "red" }}
                        ></i>
                      </p>
                    </>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>ข้อมูลการส่งอ้อย</Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md={5}>
                    <Form.Group>
                      {/* <Form.Label>เลือกโรงงาน</Form.Label> */}
                      <Form.Select
                        name="factory"
                        value={form.factory ? form.factory.factory_id : ""}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.factory}
                      >
                        <option value="">เลือกโรงงาน</option>
                        {factory.map((o) => (
                          <option key={o.factoryId} value={o.factoryId}>
                            {o.factoryCode + "-" + o.factoryName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      {/* <Form.Label>จำนวนอ้อยที่ส่ง/ตัน</Form.Label> */}
                      <FormControl
                        placeholder="จำนวนอ้อยที่ส่ง หน่วยเป็นตัน"
                        type="number"
                        name="direct_sent"
                        value={form.direct_sent}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.direct_sent}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.direct_sent}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <button
                        className="btn btn-primary btn-add-detail"
                        onClick={handleAddDirect}
                      >
                        เพิ่ม
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {directsent.map((item) => {
                    return (
                      <>
                        <li className="cademy-ui" name={item.factory_id}>
                          {" ชื่อโรงงาน : " +
                            item.factory_name +
                            " ส่งอ้อย : " +
                            item.direct_sent +
                            " ตัน"}
                          <i
                            className="bi bi-x"
                            onClick={() =>
                              handleRemoveItemDirect(item.factory_id)
                            }
                            style={{ color: "red" }}
                          ></i>
                        </li>
                      </>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>ข้อมูลลูกไร่</Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <FormControl
                        placeholder="บัตรประชาชน"
                        type="number"
                        name="under_idcard"
                        value={form.under_idcard}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.under_idcard}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.under_idcard}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <FormControl
                        placeholder="ชื่อ - นามสกุล"
                        type="text"
                        name="under_fullname"
                        value={form.under_fullname}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.under_fullname}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.under_fullname}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <FormControl
                        placeholder="จำนวนอ้อย/ตัน"
                        type="number"
                        name="under_sent"
                        value={form.under_sent}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.under_sent}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.under_sent}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md="auto">
                    <Form.Group>
                      <button
                        className="btn btn-primary btn-add-detail"
                        onClick={handleAddUnder}
                      >
                        เพิ่ม
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {undersent.map((item) => {
                    return (
                      <>
                        <li className="cademy-ui" name={item.under_idcard}>
                          {item.under_idcard +
                            " ชื่อ - สกุล : " +
                            item.under_fullname +
                            " ส่งอ้อยจำนวน " +
                            item.under_sent +
                            " ตัน"}
                          <i
                            className="bi bi-x"
                            onClick={() =>
                              handleRemoveItemUnder(item.under_idcard)
                            }
                            style={{ color: "red" }}
                          ></i>
                        </li>
                      </>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                ข้อมูลที่ดิน(รวมพื้นที่ปลูกอ้อย{" "}
                {plant.reduce((total, item) => {
                  return total + parseInt(item.deed_rai);
                }, 0)}
                {" ไร่"})
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>ประเภทที่ดิน</Form.Label> */}
                      <Form.Select
                        name="deed_type"
                        value={form.deed_type}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_type}
                      >
                        <option key="" value="">
                          เลือกประเภทที่ดิน
                        </option>
                        <option key="โฉนดที่ดิน" value="โฉนดที่ดิน">
                          โฉนดที่ดิน
                        </option>
                        <option key="โฉนดที่ดิน" value="นส3ก">
                          นส3ก
                        </option>
                        <option key="โฉนดที่ดิน" value="นส3ข">
                          นส3ข
                        </option>
                        <option
                          key="โฉนดที่ดิน"
                          value="แบบแจ้งการครอบครอบที่ดิน ส.ค.1"
                        >
                          แบบแจ้งการครอบครอบที่ดิน ส.ค.1
                        </option>
                        <option key="โฉนดที่ดิน" value="สปก.">
                          สปก.
                        </option>
                        <option key="โฉนดที่ดิน" value="ภ.บ.ท.5">
                          ภ.บ.ท.5
                        </option>
                        <option key="โฉนดที่ดิน" value="สัญญาเช่าที่ดิน">
                          สัญญาเช่าที่ดิน
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_type}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-2">
                      <Form.Check type="radio" id="check-api-radio">
                        <Form.Check.Label>
                          ประเภทเอกสาร :{"  "}
                        </Form.Check.Label>
                        <Form.Check.Input
                          name="deed_owner"
                          type="radio"
                          value="ตนเอง"
                          style={{ margin: "2px 10px" }}
                          onChange={(e) => setDeed(e.target, e.target.value)}
                          checked={form.deed_owner === "ตนเอง"}
                        />
                        <Form.Check.Label>ตนเอง</Form.Check.Label>

                        <Form.Check.Input
                          name="deed_owner"
                          type="radio"
                          value="ลูกไร่"
                          style={{ margin: "2px 10px" }}
                          onChange={(e) => setDeed(e.target, e.target.value)}
                          checked={form.deed_owner === "ลูกไร่"}
                        />
                        <Form.Check.Label>ลูกไร่</Form.Check.Label>
                        <Form.Control.Feedback type="invalid">
                          {errors.deed_owner}
                        </Form.Control.Feedback>
                      </Form.Check>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>จำนวนไร่</Form.Label> */}
                      <FormControl
                        placeholder="ขนาดพื้นที่(ไร่)"
                        type="number"
                        name="deed_rai"
                        value={form.deed_rai}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_rai}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_rai}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md="auto">
                    <Form.Group>
                      <button
                        className="btn btn-primary btn-add-detail"
                        onClick={handleAddPlant}
                      >
                        เพิ่ม
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {plant.map((item, key) => {
                    return (
                      <div key={key}>
                        <li className="cademy-ui" key={key} name={key}>
                          {" ประเภทที่ดิน : " +
                            item.deed_type +
                            " ประเภทเอกสาร : " +
                            item.deed_owner +
                            " เนื้อที่ : " +
                            item.deed_rai +
                            " ไร่"}
                          <i
                            className="bi bi-x"
                            key={key}
                            onClick={() => handleRemoveItemPlant(key)}
                            style={{ color: "red" }}
                          ></i>
                        </li>
                      </div>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          {/* {props.timereg_id == 0 ? (
            ""
          ) : (
            <div>
              <Form.Group>
                <Form.Select
                  name="approve_status"
                  value={approveStatus || ""}
                  onChange={(e) => setApproveStatus(e.target.value)}
                  // isInvalid={!!errors.academy}
                >
                  <option value="ฉบับร่าง">ฉบับร่าง</option>
                  <option value="รออนุมัติ">รออนุมัติ</option>
                </Form.Select>
              </Form.Group>
            </div>
          )} */}
          <div>
            <Form.Group>
              <Form.Select
                name="approve_status"
                value={approveStatus || ""}
                onChange={(e) => setApproveStatus(e.target.value)}
                // isInvalid={!!errors.academy}
              >
                <option value="ฉบับร่าง">ฉบับร่าง</option>
                <option value="รออนุมัติ">รออนุมัติ</option>
              </Form.Select>
            </Form.Group>
          </div>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalEditDetail;

ModalEditDetail.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  master_select: PropTypes.object,
  afterSubmit: PropTypes.func,
  timereg_id: PropTypes.number,
  // academy: PropTypes.array,
  // data: PropTypes.object,
  // setdata: PropTypes.func,
};

// ModalAddDetail.defaultProps = {
//   farmer_idcard: 0,
// };
